var map = {
	"./icon-3d-model.svg": "./src/assets/icons/icon-3d-model.svg",
	"./icon-CA.svg": "./src/assets/icons/icon-CA.svg",
	"./icon-DE.svg": "./src/assets/icons/icon-DE.svg",
	"./icon-US.svg": "./src/assets/icons/icon-US.svg",
	"./icon-account.svg": "./src/assets/icons/icon-account.svg",
	"./icon-arrow--cta-alt.svg": "./src/assets/icons/icon-arrow--cta-alt.svg",
	"./icon-arrow--cta-long.svg": "./src/assets/icons/icon-arrow--cta-long.svg",
	"./icon-arrow--cta-plus.svg": "./src/assets/icons/icon-arrow--cta-plus.svg",
	"./icon-arrow--cta-video.svg": "./src/assets/icons/icon-arrow--cta-video.svg",
	"./icon-arrow--cta.svg": "./src/assets/icons/icon-arrow--cta.svg",
	"./icon-arrow--down.svg": "./src/assets/icons/icon-arrow--down.svg",
	"./icon-arrow--left-alt.svg": "./src/assets/icons/icon-arrow--left-alt.svg",
	"./icon-arrow--left.svg": "./src/assets/icons/icon-arrow--left.svg",
	"./icon-arrow--right-alt.svg": "./src/assets/icons/icon-arrow--right-alt.svg",
	"./icon-arrow--right.svg": "./src/assets/icons/icon-arrow--right.svg",
	"./icon-arrow--up-right.svg": "./src/assets/icons/icon-arrow--up-right.svg",
	"./icon-arrow--up.svg": "./src/assets/icons/icon-arrow--up.svg",
	"./icon-arrow--view-more.svg": "./src/assets/icons/icon-arrow--view-more.svg",
	"./icon-backbutton.svg": "./src/assets/icons/icon-backbutton.svg",
	"./icon-breadcrumb--left.svg": "./src/assets/icons/icon-breadcrumb--left.svg",
	"./icon-breadcrumb--right.svg": "./src/assets/icons/icon-breadcrumb--right.svg",
	"./icon-cart-review-stars.svg": "./src/assets/icons/icon-cart-review-stars.svg",
	"./icon-cart.svg": "./src/assets/icons/icon-cart.svg",
	"./icon-check--circle.svg": "./src/assets/icons/icon-check--circle.svg",
	"./icon-close.svg": "./src/assets/icons/icon-close.svg",
	"./icon-dot.svg": "./src/assets/icons/icon-dot.svg",
	"./icon-dropdown--mobile.svg": "./src/assets/icons/icon-dropdown--mobile.svg",
	"./icon-e-optimized.svg": "./src/assets/icons/icon-e-optimized.svg",
	"./icon-livechat.svg": "./src/assets/icons/icon-livechat.svg",
	"./icon-lock.svg": "./src/assets/icons/icon-lock.svg",
	"./icon-minus.svg": "./src/assets/icons/icon-minus.svg",
	"./icon-next-sq.svg": "./src/assets/icons/icon-next-sq.svg",
	"./icon-pause.svg": "./src/assets/icons/icon-pause.svg",
	"./icon-play-alt.svg": "./src/assets/icons/icon-play-alt.svg",
	"./icon-play.svg": "./src/assets/icons/icon-play.svg",
	"./icon-plus.svg": "./src/assets/icons/icon-plus.svg",
	"./icon-prev-sq.svg": "./src/assets/icons/icon-prev-sq.svg",
	"./icon-quote.svg": "./src/assets/icons/icon-quote.svg",
	"./icon-remove.svg": "./src/assets/icons/icon-remove.svg",
	"./icon-return.svg": "./src/assets/icons/icon-return.svg",
	"./icon-search.svg": "./src/assets/icons/icon-search.svg",
	"./icon-shipping.svg": "./src/assets/icons/icon-shipping.svg",
	"./icon-slider--left.svg": "./src/assets/icons/icon-slider--left.svg",
	"./icon-slider--right.svg": "./src/assets/icons/icon-slider--right.svg",
	"./icon-tail.svg": "./src/assets/icons/icon-tail.svg",
	"./icon-tooltip.svg": "./src/assets/icons/icon-tooltip.svg",
	"./icon-trail-marker.svg": "./src/assets/icons/icon-trail-marker.svg",
	"./icon-video--play.svg": "./src/assets/icons/icon-video--play.svg",
	"./social-icons/icon-facebook.svg": "./src/assets/icons/social-icons/icon-facebook.svg",
	"./social-icons/icon-instagram.svg": "./src/assets/icons/social-icons/icon-instagram.svg",
	"./social-icons/icon-linkedin.svg": "./src/assets/icons/social-icons/icon-linkedin.svg",
	"./social-icons/icon-pinterest.svg": "./src/assets/icons/social-icons/icon-pinterest.svg",
	"./social-icons/icon-rss.svg": "./src/assets/icons/social-icons/icon-rss.svg",
	"./social-icons/icon-shopify-logo.svg": "./src/assets/icons/social-icons/icon-shopify-logo.svg",
	"./social-icons/icon-snapchat.svg": "./src/assets/icons/social-icons/icon-snapchat.svg",
	"./social-icons/icon-tumblr.svg": "./src/assets/icons/social-icons/icon-tumblr.svg",
	"./social-icons/icon-twitter.svg": "./src/assets/icons/social-icons/icon-twitter.svg",
	"./social-icons/icon-vimeo.svg": "./src/assets/icons/social-icons/icon-vimeo.svg",
	"./social-icons/icon-youtube.svg": "./src/assets/icons/social-icons/icon-youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive \\.svg$";